/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Signingout1Inputs */

const zh_danger_signingout1 = /** @type {(inputs: Danger_Signingout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在登出...`)
};

const en_danger_signingout1 = /** @type {(inputs: Danger_Signingout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing out...`)
};

const es_danger_signingout1 = /** @type {(inputs: Danger_Signingout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrando sesión...`)
};

/**
* | output |
* | --- |
* | "Signing out..." |
*
* @param {Danger_Signingout1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_signingout1 = /** @type {((inputs?: Danger_Signingout1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Signingout1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_signingout1(inputs)
	if (locale === "en") return en_danger_signingout1(inputs)
	return es_danger_signingout1(inputs)
});
export { danger_signingout1 as "danger_signingOut" }